// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wallet_main__U-tPC {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  grid-template-rows: max-content min-content;
  gap: 3rem;
}
@media only screen and (max-width: 56.25em) {
  .Wallet_main__U-tPC {
    grid-template-rows: repeat(2, max-content) min-content;
  }
}
@media only screen and (max-width: 43.75em) {
  .Wallet_main__U-tPC {
    grid-template-columns: 100%;
    grid-template-rows: repeat(4, max-content);
  }
}
@media only screen and (max-width: 56.25em) {
  .Wallet_main__U-tPC > :last-child {
    grid-column: 1/3;
    grid-row: 2/3;
    margin-bottom: 5rem;
  }
}
@media only screen and (max-width: 43.75em) {
  .Wallet_main__U-tPC > :last-child {
    grid-column: 1/2;
    grid-row: 3/4;
  }
}
@media only screen and (max-width: 56.25em) {
  .Wallet_main__U-tPC > :nth-child(3) {
    grid-column: 1/3;
  }
}
@media only screen and (max-width: 43.75em) {
  .Wallet_main__U-tPC > :nth-child(3) {
    grid-column: 1/2;
  }
}

.Wallet_paystackButton__JIPLS {
  width: 38rem;
  border-radius: 1rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
  box-sizing: border-box;
  padding: 1.9rem 2.2rem;
  justify-content: center;
  margin-top: 2rem;
}
.Wallet_paystackButton_container__3MY9f {
  display: flex;
  justify-content: center;
}

.Wallet_wallets__E25sf {
  display: grid;
  grid-template-columns: 100%;
  gap: 2rem;
  margin-bottom: 2rem;
  width: 100%;
}

.Wallet_lowerHalf__6bO2H {
  display: grid;
  grid-template-columns: 55% 45%;
  gap: 2rem;
}
.Wallet_lowerHalf__6bO2H > :nth-child(2) > :nth-child(1) {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Wallet_lowerHalf__6bO2H {
    grid-template-columns: 100%;
  }
  .Wallet_lowerHalf__6bO2H > :nth-child(1) {
    grid-row: 2/3;
  }
  .Wallet_lowerHalf__6bO2H > :nth-child(2) {
    grid-row: 1/2;
  }
}

.Wallet_balance__X92nW {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 3rem;
  border-radius: 1rem;
  background-color: var(--color-table-grey);
  color: var(--color-dark);
  background-size: cover;
  transition: all 0.4s;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}
.Wallet_balance__side__VQEiC {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Wallet_balance__amount__C7FbD {
  display: flex;
  flex-direction: column;
}
.Wallet_balance__btns__BSISc {
  display: flex;
}
.Wallet_balance__btns__BSISc > :not(:last-child) {
  margin-right: 1rem;
}

.Wallet_card__WjW1E {
  display: flex;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  background-size: cover;
  transition: all 0.4s;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  gap: 2rem;
}

.Wallet_selectCurrency__O1O6R {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Wallet_selectCurrency__text__GpFnX {
  display: flex;
  margin-left: 1rem;
}
.Wallet_selectCurrency__icon__S7qq3 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-fash-primary-2);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-fash-primary-2);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Wallet_selectCurrency__icon__S7qq3:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Wallet_selectCurrency__icon_active__VqL2p {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-fash-primary-3);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-fash-primary-3);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Wallet_selectCurrency__list__alcBW {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-fash-primary-3);
}
.Wallet_selectCurrency__list_active__F1Yk5 {
  background-color: var(--color-light);
  color: var(--color-fash-primary-3);
  font-weight: 700;
}
.Wallet_selectCurrency__list__alcBW li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Wallet_selectCurrency__list__alcBW li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.Wallet_exchange__PE-Hg {
  margin-top: 2rem;
  width: 40rem;
  height: 10rem;
  box-sizing: border-box;
  background-color: var(--color-table-grey-1);
  border-radius: 1rem;
  padding: 1rem 3rem;
  display: flex;
  align-items: center;
}
.Wallet_exchange__PE-Hg > :not(:last-child) {
  margin-right: 1rem;
}
.Wallet_exchange__side__HH0TT {
  display: flex;
  align-items: center;
}
.Wallet_exchange__input__uDZ\\+X {
  background-color: transparent;
  outline: none;
  border-bottom: 1px solid var(--color-dark);
  width: 15rem;
}

.Wallet_pin__z8VO\\+ {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  padding-left: 2rem;
}
.Wallet_pin__label__Nbnsp {
  font-size: var(--default-font-small);
  font-family: inherit;
  padding-left: 4rem;
}
.Wallet_pin__group__OcgDv {
  margin: 3rem auto;
}
.Wallet_pin__item__lmO8b {
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/Wallet.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,gCAAA;EACA,2CAAA;EACA,SAAA;AADF;AAGE;EANF;IAOI,sDAAA;EAAF;AACF;AAEE;EAVF;IAWI,2BAAA;IACA,0CAAA;EACF;AACF;AAEI;EADF;IAEI,gBAAA;IACA,aAAA;IACA,mBAAA;EACJ;AACF;AACI;EAPF;IAQI,gBAAA;IACA,aAAA;EAEJ;AACF;AAEI;EADF;IAEI,gBAAA;EACJ;AACF;AACI;EALF;IAMI,gBAAA;EAEJ;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;AACJ;;AAGA;EACE,aAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAAF;;AAgBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAbF;AAgBI;EACE,mBAAA;AAdN;AAkBE;EAXF;IAYI,2BAAA;EAfF;EAiBE;IACE,aAAA;EAfJ;EAkBE;IACE,aAAA;EAhBJ;AACF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,wBAAA;EAGA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;AAnBF;AA2BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,sBAAA;AA1BJ;AA6BE;EACE,aAAA;AA3BJ;AA6BI;EACE,kBAAA;AA3BN;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,SAAA;AA7BF;;AAwCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AArCF;AAuCE;EACE,aAAA;EACA,iBAAA;AArCJ;AAwCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAtCJ;AAwCI;EACE,4DACE;EAEF,wCAAA;EACA,2BAAA;AAxCN;AA2CI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACE;EAEF,wCAAA;EACA,2BAAA;AA3CN;AA+CE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACE;EAEF,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6CAAA;AA/CJ;AAiDI;EACE,oCAAA;EACA,kCAAA;EACA,gBAAA;AA/CN;AAkDI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAhDN;AAkDM;EACE,wCAAA;EACA,2BAAA;EACA,gBAAA;AAhDR;;AAsDA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAnDF;AAqDE;EACE,kBAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,mBAAA;AApDJ;AAuDE;EACE,6BAAA;EACA,aAAA;EACA,0CAAA;EACA,YAAA;AArDJ;;AAyDA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAtDF;AAwDE;EACE,oCAAA;EACA,oBAAA;EACA,kBAAA;AAtDJ;AAyDE;EACE,iBAAA;AAvDJ;AA0DE;EACE,kBAAA;AAxDJ","sourcesContent":["@import \"../variables/breakpoints\";\n\n.main {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  grid-template-rows: max-content min-content;\n  gap: 3rem;\n\n  @media only screen and (max-width: $bp-900) {\n    grid-template-rows: repeat(2, max-content) min-content;\n  }\n\n  @media only screen and (max-width: $bp-700) {\n    grid-template-columns: 100%;\n    grid-template-rows: repeat(4, max-content);\n  }\n\n  & > :last-child {\n    @media only screen and (max-width: $bp-900) {\n      grid-column: 1/3;\n      grid-row: 2/3;\n      margin-bottom: 5rem;\n    }\n\n    @media only screen and (max-width: $bp-700) {\n      grid-column: 1/2;\n      grid-row: 3/4;\n    }\n  }\n\n  & > :nth-child(3) {\n    @media only screen and (max-width: $bp-900) {\n      grid-column: 1/3;\n    }\n\n    @media only screen and (max-width: $bp-700) {\n      grid-column: 1/2;\n    }\n  }\n}\n\n.paystackButton {\n  width: 38rem;\n  border-radius: 1rem;\n  background-color: var(--color-dark);\n  color: var(--color-white);\n  font-weight: 700;\n  box-sizing: border-box;\n  padding: 1.9rem 2.2rem;\n  justify-content: center;\n  margin-top: 2rem;\n\n  &_container {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.wallets {\n  display: grid;\n  grid-template-columns: 100%;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  width: 100%;\n  // overflow-x: scroll;\n\n  // &::-webkit-scrollbar {\n  // \theight: 1rem;\n  // \tbackground-color: var(--color-light);\n  // \tborder-radius: 0 1rem 1rem 0;\n  // }\n\n  // &::-webkit-scrollbar-thumb {\n  // \tbackground-color: var(--color-grey);\n  // \tborder-radius: 1rem;\n\n  // }\n}\n\n.lowerHalf {\n  display: grid;\n  grid-template-columns: 55% 45%;\n  gap: 2rem;\n\n  & > :nth-child(2) {\n    & > :nth-child(1) {\n      margin-bottom: 2rem;\n    }\n  }\n\n  @media only screen and (max-width: $bp-600) {\n    grid-template-columns: 100%;\n\n    & > :nth-child(1) {\n      grid-row: 2/3;\n    }\n\n    & > :nth-child(2) {\n      grid-row: 1/2;\n    }\n  }\n}\n\n.balance {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 3rem;\n  border-radius: 1rem;\n  background-color: var(--color-table-grey);\n  color: var(--color-dark);\n  // background-color: var(--color-fash-primary-4);\n  // background-image: url(\"../../img/background.png\");\n  background-size: cover;\n  transition: all 0.4s;\n  width: 100%;\n  height: fit-content;\n  // min-width: 50rem;\n\n  // @media only screen and (max-width: 56.25em) {\n  // \tpadding: 3rem 2rem;\n  // \tmin-width: 38rem;\n  // }\n\n  &__side {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__amount {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__btns {\n    display: flex;\n\n    & > :not(:last-child) {\n      margin-right: 1rem;\n    }\n  }\n}\n\n.card {\n  display: flex;\n  box-sizing: border-box;\n  padding: 2rem;\n  border-radius: 1rem;\n  background-color: var(--color-white);\n  background-size: cover;\n  transition: all 0.4s;\n  width: 100%;\n  height: fit-content;\n  gap: 2rem;\n\n  // &_moneyIn {\n  //   background-color: var(--color-primary-7);\n  // }\n\n  // &_moneyOut {\n  //   background-color: var(--color-light-red);\n  // }\n}\n\n.selectCurrency {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: var(--default-font-small);\n  position: relative;\n  margin-left: 2rem;\n\n  &__text {\n    display: flex;\n    margin-left: 1rem;\n  }\n\n  &__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 3rem;\n    background-color: #f2f0f0;\n    color: var(--color-fash-primary-2);\n    width: 5rem;\n    height: 5rem;\n    border-radius: 5rem;\n    border: solid 1px var(--color-fash-primary-2);\n    cursor: pointer;\n    transform: rotateZ(0);\n    transition-duration: 500ms;\n\n    &:hover {\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n\n    &_active {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 3rem;\n      background-color: #f2f0f0;\n      color: var(--color-fash-primary-3);\n      width: 5rem;\n      height: 5rem;\n      border-radius: 5rem;\n      border: solid 1px var(--color-fash-primary-3);\n      cursor: pointer;\n      transition-duration: 500ms;\n      box-shadow:\n        10px 10px 45px #bebebe,\n        -15px -15px 30px #ffffff;\n      background-color: var(--color-primary-3);\n      transform: rotateZ(-180deg);\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    width: 5rem;\n    background-color: #f2f0f0;\n    color: var(--color-dark);\n    border-radius: 1rem;\n    box-shadow:\n      10px 10px 45px #bebebe,\n      -15px -15px 30px #ffffff;\n    position: absolute;\n    top: 6rem;\n    z-index: 30;\n    border: solid 1px var(--color-fash-primary-3);\n\n    &_active {\n      background-color: var(--color-light);\n      color: var(--color-fash-primary-3);\n      font-weight: 700;\n    }\n\n    li {\n      list-style: none;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      border-radius: 1rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--color-primary-7);\n        color: var(--color-primary);\n        font-weight: 700;\n      }\n    }\n  }\n}\n\n.exchange {\n  margin-top: 2rem;\n  width: 40rem;\n  height: 10rem;\n  box-sizing: border-box;\n  background-color: var(--color-table-grey-1);\n  border-radius: 1rem;\n  padding: 1rem 3rem;\n  display: flex;\n  align-items: center;\n\n  & > :not(:last-child) {\n    margin-right: 1rem;\n  }\n\n  &__side {\n    display: flex;\n    align-items: center;\n  }\n\n  &__input {\n    background-color: transparent;\n    outline: none;\n    border-bottom: 1px solid var(--color-dark);\n    width: 15rem;\n  }\n}\n\n.pin {\n  display: flex;\n  gap: 2rem;\n  margin-top: 1rem;\n  padding-left: 2rem;\n\n  &__label {\n    font-size: var(--default-font-small);\n    font-family: inherit;\n    padding-left: 4rem;\n  }\n\n  &__group {\n    margin: 3rem auto;\n  }\n\n  &__item {\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Wallet_main__U-tPC`,
	"paystackButton": `Wallet_paystackButton__JIPLS`,
	"paystackButton_container": `Wallet_paystackButton_container__3MY9f`,
	"wallets": `Wallet_wallets__E25sf`,
	"lowerHalf": `Wallet_lowerHalf__6bO2H`,
	"balance": `Wallet_balance__X92nW`,
	"balance__side": `Wallet_balance__side__VQEiC`,
	"balance__amount": `Wallet_balance__amount__C7FbD`,
	"balance__btns": `Wallet_balance__btns__BSISc`,
	"card": `Wallet_card__WjW1E`,
	"selectCurrency": `Wallet_selectCurrency__O1O6R`,
	"selectCurrency__text": `Wallet_selectCurrency__text__GpFnX`,
	"selectCurrency__icon": `Wallet_selectCurrency__icon__S7qq3`,
	"selectCurrency__icon_active": `Wallet_selectCurrency__icon_active__VqL2p`,
	"selectCurrency__list": `Wallet_selectCurrency__list__alcBW`,
	"selectCurrency__list_active": `Wallet_selectCurrency__list_active__F1Yk5`,
	"exchange": `Wallet_exchange__PE-Hg`,
	"exchange__side": `Wallet_exchange__side__HH0TT`,
	"exchange__input": `Wallet_exchange__input__uDZ+X`,
	"pin": `Wallet_pin__z8VO+`,
	"pin__label": `Wallet_pin__label__Nbnsp`,
	"pin__group": `Wallet_pin__group__OcgDv`,
	"pin__item": `Wallet_pin__item__lmO8b`
};
export default ___CSS_LOADER_EXPORT___;
